import { CheckBox, CustomVideoPlayer } from '@room-match/shared-ui-components';
import React from 'react';
import { useQueryClient } from 'react-query';
import IMedia from 'shared/interfaces/IMedia';
import { VideoItemCont } from './Item.styles';
import AsyncVideoEditor from 'components/AsyncVideoEditor/AsyncVideoEditor';
import { CONFIG } from 'shared/config';
import VideoPlayer from 'components/Media/VideoPlayer/VideoPlayer';
interface Props {
  item: IMedia;
  checked?: boolean;
  handleSelect?: (m: IMedia) => void;
  trimmable?: boolean;
}

const VideoItem: React.FC<Props> = ({ item, checked, handleSelect, trimmable }) => {
  const queryClient = useQueryClient();

  const handleTrim = () => {
    queryClient.invalidateQueries('media');
  };

  return (
    <VideoItemCont style={{ all: 'unset', width: '100%', position: 'relative' }}>
      {handleSelect && (
        <div style={{ position: 'absolute', top: -5, left: -5, zIndex: 10 }}>
          <CheckBox checked={checked} onClick={() => handleSelect(item)} />
        </div>
      )}

      {trimmable && CONFIG.APP_ENV !== 'production' ? (
        <AsyncVideoEditor
          wrapperStyles={{
            width: '100%',
            height: '100%',
          }}
          updateProgress={(data: { status: string; progress: number }) => {
            console.log(data);
          }}
          onTrim={handleTrim}
          videoUrl={item.attributes.attachment_url}
          mediaId={item.id}
        >
          <VideoPlayer
            url={item.attributes.modified_attachment_url || item.attributes.attachment_url}
            fileName={item?.attributes?.file_name}
            showDuration
          />
        </AsyncVideoEditor>
      ) : (
        <VideoPlayer
          url={item.attributes.modified_attachment_url || item.attributes.attachment_url}
          fileName={item?.attributes?.file_name}
          showDuration
        />
        /* Commenting this out for now; will remove it once the test passes. */
        // <div style={{ flex: 1, height: '100%', borderRadius: 10, boxShadow: '0 0 10px 0 #2d343e' }}>
        //   <CustomVideoPlayer
        //     isSmall
        //     classes={{ root: 'profile-video-item', videoPlayer: '', icon: '' }}
        //     url={item.attributes.modified_attachment_url || item.attributes.attachment_url}
        //   />
        // </div>
      )}
    </VideoItemCont>
  );
};

export default VideoItem;
